__turbopack_context__.v({
  "counter": "Tag-module___boTyW__counter",
  "danger": "Tag-module___boTyW__danger",
  "default": "Tag-module___boTyW__default",
  "filled": "Tag-module___boTyW__filled",
  "icon": "Tag-module___boTyW__icon",
  "info": "Tag-module___boTyW__info",
  "label": "Tag-module___boTyW__label",
  "md": "Tag-module___boTyW__md",
  "metric-down": "Tag-module___boTyW__metric-down",
  "metric-lg": "Tag-module___boTyW__metric-lg",
  "metric-md": "Tag-module___boTyW__metric-md",
  "metric-neutral": "Tag-module___boTyW__metric-neutral",
  "metric-sm": "Tag-module___boTyW__metric-sm",
  "metric-up": "Tag-module___boTyW__metric-up",
  "metricBadge": "Tag-module___boTyW__metricBadge",
  "minimal": "Tag-module___boTyW__minimal",
  "minimalOutline": "Tag-module___boTyW__minimalOutline",
  "neutral": "Tag-module___boTyW__neutral",
  "primary": "Tag-module___boTyW__primary",
  "removeButton": "Tag-module___boTyW__removeButton",
  "removeIcon": "Tag-module___boTyW__removeIcon",
  "signal": "Tag-module___boTyW__signal",
  "skill": "Tag-module___boTyW__skill",
  "skillUnselected": "Tag-module___boTyW__skillUnselected",
  "sm": "Tag-module___boTyW__sm",
  "success": "Tag-module___boTyW__success",
  "tag": "Tag-module___boTyW__tag",
  "trendIcon": "Tag-module___boTyW__trendIcon",
  "warning": "Tag-module___boTyW__warning",
});
